var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "Capa_1",
        "data-name": "Capa 1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        version: "1.1",
        viewBox: "0 0 1133.858 566.929"
      }
    },
    [
      _c(
        "defs",
        [
          _c("svg:style", { attrs: { type: "text/css" } }, [
            _vm._v(
              "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_2-10);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_2-11);\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_2);\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_2-7);\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_sin_nombre_2-4);\n      }\n\n      .cls-6 {\n        fill: url(#Degradado_sin_nombre_2-9);\n      }\n\n      .cls-7 {\n        fill: url(#Degradado_sin_nombre_2-6);\n      }\n\n      .cls-8 {\n        fill: url(#Degradado_sin_nombre_2-8);\n      }\n\n      .cls-9 {\n        fill: url(#Degradado_sin_nombre_2-5);\n      }\n\n      .cls-10 {\n        fill: url(#Degradado_sin_nombre_2-3);\n      }\n\n      .cls-11 {\n        fill: url(#Degradado_sin_nombre_2-2);\n      }\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "Degradado_sin_nombre_2",
                "data-name": "Degradado sin nombre 2",
                x1: "111.231",
                y1: "274.531",
                x2: "1018.721",
                y2: "274.531",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { offset: "0", "stop-color": "#ce317c" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: ".189", "stop-color": "#b22f73" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: ".595", "stop-color": "#6b2a5d" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#1f2646" } })
            ],
            1
          ),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-2",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "285.59",
              x2: "1009.64",
              y2: "285.59",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-3",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "273.505",
              x2: "1009.64",
              y2: "273.505",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-4",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "285.177",
              x2: "1009.64",
              y2: "285.177",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-5",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "268.952",
              x2: "1009.64",
              y2: "268.952",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-6",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "285.591",
              x2: "1009.64",
              y2: "285.591",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-7",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "269.365",
              x2: "1009.64",
              y2: "269.365",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-8",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "285.59",
              x2: "1009.64",
              y2: "285.59",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-9",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "273.505",
              x2: "1009.64",
              y2: "273.505",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-10",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "285.59",
              x2: "1009.64",
              y2: "285.59",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          }),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "Degradado_sin_nombre_2-11",
              "data-name": "Degradado sin nombre 2",
              x1: "122.551",
              y1: "285.59",
              x2: "1009.64",
              y2: "285.59",
              "xlink:href": "#Degradado_sin_nombre_2"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("path", {
        staticClass: "cls-3",
        attrs: {
          d:
            "M1002.688,157.202H131.17c-7.99,0-14.469,6.472-14.469,14.462v205.733c0,7.99,6.479,14.462,14.47,14.462h356.415c7.99,0,14.473-6.472,14.473-14.462s-6.483-14.473-14.473-14.473H145.632v-176.787h842.593v176.787h-341.953c-7.99,0-14.473,6.476-14.473,14.473s6.483,14.462,14.473,14.462h356.415c7.99,0,14.47-6.472,14.47-14.462v-205.733c0-7.99-6.479-14.462-14.47-14.462Z"
        }
      }),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          staticClass: "cls-11",
          attrs: {
            d:
              "M204.56,325.244c-4.966-1.49-9.106-3.283-12.418-5.381-3.752-2.318-5.629-5.41-5.629-9.272,0-2.539.938-4.719,2.814-6.54,1.876-1.822,4.139-2.732,6.788-2.732,1.987,0,4.249.717,6.788,2.151,2.87,1.657,5.906,3.035,9.106,4.139,3.201,1.105,6.733,1.657,10.596,1.657,4.195,0,7.313-.69,9.354-2.07,2.043-1.38,3.063-3.174,3.063-5.381,0-1.876-.745-3.339-2.235-4.387-1.491-1.05-4.609-1.849-9.354-2.401l-8.776-.994c-8.72-.994-15.259-3.587-19.619-7.782-4.36-4.195-6.54-9.768-6.54-16.721,0-7.947,2.869-14.239,8.609-18.876,5.739-4.635,13.907-6.953,24.504-6.953,4.525,0,8.857.442,12.996,1.325,4.14.882,7.92,2.207,11.342,3.974,4.525,2.318,6.788,5.354,6.788,9.106,0,2.539-.829,4.691-2.484,6.457-1.655,1.767-3.863,2.649-6.623,2.649-.883,0-1.821-.138-2.814-.413-.994-.277-2.263-.802-3.808-1.574-4.967-2.316-10.375-3.476-16.225-3.476-3.532,0-6.099.579-7.699,1.738-1.6,1.159-2.401,2.676-2.401,4.554s.718,3.337,2.153,4.387c1.434,1.048,4.415,1.794,8.94,2.234l8.775.994c9.493,1.103,16.309,3.752,20.447,7.947,4.139,4.195,6.208,9.658,6.208,16.392,0,8.278-3.118,14.927-9.354,19.951-6.236,5.021-15.039,7.532-26.408,7.532-6.291,0-11.921-.744-16.887-2.234Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-10",
          attrs: {
            d:
              "M279.16,320.111c-3.808-4.36-5.712-11.121-5.712-20.281v-36.095c0-.661-.386-.992-1.159-.992h-.661c-2.981,0-5.271-.802-6.872-2.401-1.6-1.601-2.4-3.67-2.4-6.209s.8-4.608,2.4-6.209c1.6-1.599,3.891-2.401,6.872-2.401h.661c.773,0,1.159-.331,1.159-.992v-11.921c0-3.864,1.077-6.871,3.229-9.024,2.152-2.153,4.94-3.228,8.361-3.228,3.311,0,6.043,1.075,8.195,3.228,2.152,2.153,3.229,5.16,3.229,9.024v11.921c0,.661.332.992.993.992h6.292c2.98,0,5.27.802,6.871,2.401,1.6,1.601,2.401,3.67,2.401,6.209s-.801,4.608-2.401,6.209c-1.6,1.599-3.891,2.401-6.871,2.401h-6.292c-.661,0-.993.331-.993.992v35.431c0,2.428.469,4.195,1.407,5.298.938,1.103,2.512,1.767,4.718,1.986,3.643.442,6.264,1.628,7.864,3.56,1.6,1.932,2.401,4.168,2.401,6.705,0,2.87-1.021,5.244-3.063,7.121-2.042,1.876-5.27,2.814-9.686,2.814h-.993c-9.493,0-16.142-2.18-19.951-6.54Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-5",
          attrs: {
            d:
              "M326.858,323.422c-2.153-2.151-3.229-5.16-3.229-9.024v-57.616c0-3.864,1.076-6.871,3.229-9.024,2.152-2.151,4.939-3.228,8.36-3.228,2.76,0,5.161.773,7.202,2.318,2.043,1.544,3.394,3.752,4.056,6.621v.167h.165c1.877-2.649,4.553-4.967,8.031-6.955,3.477-1.986,7.533-2.98,12.169-2.98,1.876,0,3.477.138,4.801.413,1.325.277,2.539.69,3.643,1.242,2.097.994,3.642,2.318,4.636,3.974.993,1.657,1.49,3.478,1.49,5.465,0,3.42-1.049,6.236-3.146,8.443-2.097,2.207-4.856,3.31-8.278,3.31-1.435,0-3.091-.275-4.967-.827-1.876-.552-3.863-.829-5.96-.829-4.304,0-7.422,1.463-9.354,4.387-1.931,2.926-2.897,7.092-2.897,12.501v32.615c0,3.864-1.104,6.873-3.311,9.024-2.208,2.153-4.967,3.23-8.279,3.23-3.422,0-6.208-1.077-8.36-3.23Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-9",
          attrs: {
            d:
              "M393.776,233.604c-2.539-2.539-3.807-5.631-3.807-9.274s1.269-6.732,3.807-9.27c2.539-2.539,5.63-3.808,9.272-3.808s6.733,1.269,9.272,3.808c2.539,2.538,3.808,5.629,3.808,9.27s-1.27,6.734-3.808,9.274c-2.539,2.538-5.629,3.806-9.272,3.806s-6.733-1.269-9.272-3.806ZM394.687,323.422c-2.153-2.151-3.229-5.16-3.229-9.024v-57.616c0-3.864,1.076-6.871,3.229-9.024,2.152-2.151,4.939-3.228,8.36-3.228,3.311,0,6.071,1.077,8.279,3.228,2.207,2.153,3.311,5.16,3.311,9.024v57.616c0,3.864-1.104,6.873-3.311,9.024-2.208,2.153-4.967,3.23-8.279,3.23-3.422,0-6.208-1.077-8.36-3.23Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-7",
          attrs: {
            d:
              "M476.987,321.519l-15.066-19.868h-.166l-15.067,19.868c-2.649,3.422-5.85,5.133-9.602,5.133-2.98,0-5.437-.994-7.368-2.98-1.932-1.988-2.898-4.36-2.898-7.121,0-2.538.939-5.077,2.815-7.616l18.874-24.668-16.887-22.021c-1.876-2.538-2.814-5.077-2.814-7.616,0-2.759.965-5.131,2.897-7.119,1.931-1.988,4.387-2.98,7.368-2.98,3.752,0,6.954,1.711,9.603,5.133l13.079,17.219h.166l13.079-17.219c2.649-3.422,5.85-5.133,9.603-5.133,2.98,0,5.436.992,7.368,2.98,1.931,1.988,2.897,4.36,2.897,7.119,0,2.539-.938,5.079-2.814,7.616l-16.887,22.021,18.874,24.668c1.876,2.539,2.814,5.079,2.814,7.616,0,2.761-.966,5.133-2.897,7.121-1.932,1.986-4.388,2.98-7.368,2.98-3.753,0-6.954-1.711-9.603-5.133Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-4",
          attrs: {
            d:
              "M560.18,323.422c-2.152-2.151-3.229-5.16-3.229-9.024v-50.663c0-.661-.386-.992-1.159-.992h-.661c-2.981,0-5.271-.802-6.872-2.401-1.6-1.601-2.4-3.67-2.4-6.209s.8-4.608,2.4-6.209c1.6-1.599,3.891-2.401,6.872-2.401h.661c.773,0,1.159-.331,1.159-.992v-3.808c0-9.823,2.263-16.888,6.788-21.192,4.526-4.304,11.645-6.457,21.359-6.457h1.655c3.532,0,6.181.882,7.947,2.649,1.767,1.767,2.649,4.029,2.649,6.788,0,2.87-.882,5.189-2.649,6.953-1.766,1.767-4.249,2.649-7.45,2.649-2.539,0-4.36.636-5.463,1.905-1.104,1.269-1.656,3.393-1.656,6.375v4.139c0,.661.332.992.994.992h6.291c2.981,0,5.271.802,6.872,2.401,1.6,1.601,2.4,3.67,2.4,6.209s-.8,4.608-2.4,6.209c-1.6,1.599-3.891,2.401-6.872,2.401h-6.291c-.662,0-.994.331-.994.992v50.663c0,3.864-1.103,6.873-3.311,9.024-2.207,2.153-4.966,3.23-8.278,3.23-3.422,0-6.209-1.077-8.361-3.23ZM615.23,320.029c-3.642-4.416-5.463-10.708-5.463-18.876v-76.822c0-3.862,1.077-6.871,3.229-9.022,2.152-2.153,4.94-3.23,8.361-3.23,3.31,0,6.07,1.077,8.278,3.23,2.208,2.151,3.311,5.16,3.311,9.022v74.836c0,2.318.414,4.029,1.242,5.133s2.18,1.82,4.056,2.151c3.311.554,5.684,1.74,7.12,3.56,1.435,1.822,2.152,4.002,2.152,6.54,0,2.87-.966,5.271-2.897,7.203-1.932,1.93-4.995,2.897-9.189,2.897h-.994c-9.161,0-15.563-2.209-19.206-6.623Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-8",
          attrs: {
            d:
              "M668.754,321.519c-5.96-3.974-10.155-9.658-12.583-17.053-.883-2.87-1.546-5.767-1.987-8.693-.442-2.924-.662-6.319-.662-10.181s.22-7.257.662-10.183c.441-2.924,1.103-5.823,1.987-8.693,2.428-7.393,6.623-13.078,12.583-17.052,5.96-3.974,13.356-5.961,22.185-5.961s16.226,1.988,22.186,5.961c5.96,3.974,10.154,9.658,12.583,17.052.882,2.87,1.545,5.769,1.987,8.693.441,2.926.662,6.319.662,10.183s-.221,7.257-.662,10.181c-.442,2.926-1.104,5.823-1.987,8.693-2.429,7.395-6.623,13.08-12.583,17.053-5.96,3.974-13.356,5.959-22.186,5.959s-16.225-1.986-22.185-5.959ZM698.886,305.624c2.097-1.546,3.587-3.752,4.471-6.623.552-1.767.938-3.752,1.159-5.961.22-2.207.331-4.691.331-7.449s-.111-5.244-.331-7.451c-.221-2.207-.607-4.195-1.159-5.959-.883-2.87-2.373-5.079-4.471-6.623-2.097-1.546-4.746-2.318-7.947-2.318s-5.85.773-7.947,2.318c-2.097,1.544-3.587,3.752-4.47,6.623-.553,1.765-.939,3.752-1.159,5.959-.221,2.207-.332,4.691-.332,7.451s.111,5.242.332,7.449c.22,2.209.607,4.195,1.159,5.961.882,2.87,2.372,5.077,4.47,6.623s4.746,2.318,7.947,2.318,5.85-.773,7.947-2.318Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-6",
          attrs: {
            d:
              "M749.664,320.111c-3.808-4.36-5.712-11.121-5.712-20.281v-36.095c0-.661-.386-.992-1.158-.992h-.663c-2.98,0-5.27-.802-6.871-2.401-1.6-1.601-2.401-3.67-2.401-6.209s.801-4.608,2.401-6.209c1.6-1.599,3.891-2.401,6.871-2.401h.663c.772,0,1.158-.331,1.158-.992v-11.921c0-3.864,1.077-6.871,3.229-9.024,2.152-2.153,4.94-3.228,8.361-3.228,3.311,0,6.043,1.075,8.195,3.228,2.152,2.153,3.229,5.16,3.229,9.024v11.921c0,.661.331.992.994.992h6.291c2.981,0,5.27.802,6.871,2.401,1.6,1.601,2.401,3.67,2.401,6.209s-.801,4.608-2.401,6.209c-1.6,1.599-3.89,2.401-6.871,2.401h-6.291c-.663,0-.994.331-.994.992v35.431c0,2.428.469,4.195,1.407,5.298.938,1.103,2.512,1.767,4.718,1.986,3.643.442,6.264,1.628,7.864,3.56,1.6,1.932,2.401,4.168,2.401,6.705,0,2.87-1.021,5.244-3.063,7.121-2.042,1.876-5.27,2.814-9.685,2.814h-.994c-9.493,0-16.142-2.18-19.951-6.54Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d:
              "M867.726,315.89c0,3.089-1.131,5.656-3.394,7.697-2.263,2.043-4.995,3.064-8.196,3.064-4.194,0-7.34-1.49-9.437-4.471l-1.987-2.814h-.165c-2.097,2.539-5.161,4.525-9.189,5.961-4.029,1.434-8.527,2.151-13.493,2.151-10.376,0-18.047-2.18-23.014-6.54-4.967-4.36-7.45-10.346-7.45-17.963,0-8.83,3.034-15.343,9.105-19.537,6.071-4.195,14.073-6.292,24.008-6.292h14.403c.662,0,.994-.331.994-.992v-.829c0-3.752-1.325-6.678-3.974-8.776-2.649-2.097-6.789-3.145-12.418-3.145-2.539,0-4.94.248-7.202.746-2.263.496-4.167,1.021-5.712,1.573-.993.331-1.931.607-2.814.827-.882.221-1.766.333-2.649.333-2.76,0-4.994-.829-6.705-2.484-1.711-1.655-2.566-3.92-2.566-6.788,0-1.767.442-3.478,1.325-5.133.883-1.657,2.429-3.035,4.636-4.139,2.649-1.325,5.988-2.43,10.017-3.312,4.029-.882,8.858-1.325,14.487-1.325,12.142,0,21.138,2.87,26.987,8.61,5.85,5.738,8.775,13.632,8.775,23.676v21.854c0,1.876.111,3.366.332,4.47.22,1.105.607,2.153,1.158,3.147l2.153,3.641c1.325,2.209,1.987,4.471,1.987,6.79ZM839.911,299.002v-5.463c0-.663-.332-.994-.994-.994h-11.258c-9.492,0-14.238,3.035-14.238,9.106,0,5.629,3.863,8.443,11.589,8.443,9.934,0,14.901-3.697,14.901-11.092Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-2",
          attrs: {
            d:
              "M894.696,325.244c-4.966-1.49-9.106-3.283-12.418-5.381-3.752-2.318-5.629-5.41-5.629-9.272,0-2.539.938-4.719,2.814-6.54,1.876-1.822,4.139-2.732,6.788-2.732,1.987,0,4.249.717,6.788,2.151,2.87,1.657,5.906,3.035,9.106,4.139,3.201,1.105,6.733,1.657,10.596,1.657,4.195,0,7.313-.69,9.354-2.07,2.043-1.38,3.063-3.174,3.063-5.381,0-1.876-.745-3.339-2.235-4.387-1.491-1.05-4.609-1.849-9.354-2.401l-8.776-.994c-8.72-.994-15.259-3.587-19.619-7.782-4.36-4.195-6.54-9.768-6.54-16.721,0-7.947,2.869-14.239,8.609-18.876,5.739-4.635,13.907-6.953,24.504-6.953,4.525,0,8.857.442,12.996,1.325,4.14.882,7.92,2.207,11.342,3.974,4.525,2.318,6.788,5.354,6.788,9.106,0,2.539-.829,4.691-2.484,6.457-1.655,1.767-3.863,2.649-6.623,2.649-.883,0-1.821-.138-2.814-.413-.994-.277-2.263-.802-3.808-1.574-4.967-2.316-10.375-3.476-16.225-3.476-3.532,0-6.099.579-7.699,1.738s-2.401,2.676-2.401,4.554.718,3.337,2.153,4.387c1.434,1.048,4.415,1.794,8.94,2.234l8.775.994c9.493,1.103,16.309,3.752,20.447,7.947,4.139,4.195,6.208,9.658,6.208,16.392,0,8.278-3.118,14.927-9.354,19.951-6.236,5.021-15.039,7.532-26.408,7.532-6.291,0-11.921-.744-16.887-2.234Z"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }